import { atom, useAtomValue } from 'jotai'

export type NodeTimelineVariant = 'DEFAULT' | 'INSPECTOR'

export const nodeTimelineVariantAtom = atom<NodeTimelineVariant>('DEFAULT')

export const useNodeTimelineVariant = (): NodeTimelineVariant =>
  useAtomValue(nodeTimelineVariantAtom)
